let ctx = null;
let master = null;
let muted = localStorage.getItem("sq_muted") === "1";
const listeners = new Set();

function ac() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = muted ? 0 : 0.5;
    master.connect(ctx.destination);
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

const mf = (n) => 440 * Math.pow(2, (n - 69) / 12);

function tone(freq, start, dur, type = "square", vol = 0.15, slideTo) {
  const c = ac();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, start);
  if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, start + dur);
  g.gain.setValueAtTime(vol, start);
  g.gain.exponentialRampToValueAtTime(0.0008, start + dur);
  o.connect(g);
  g.connect(master);
  o.start(start);
  o.stop(start + dur + 0.03);
}

const seq = (notes, step = 0.09, type = "square", vol = 0.14) => {
  const c = ac();
  if (!c) return;
  const t = c.currentTime + 0.01;
  notes.forEach((n, i) => n && tone(mf(n), t + i * step, step * 1.6, type, vol));
};

export const sfx = {
  blip: () => { const c = ac(); c && tone(880, c.currentTime, 0.04, "square", 0.05); },
  join: () => seq([84, 88], 0.05, "square", 0.045),
  tap: () => { const c = ac(); c && tone(660, c.currentTime, 0.08, "square", 0.12, 990); },
  tick: () => { const c = ac(); c && tone(1200, c.currentTime, 0.05, "square", 0.08); },
  chime: () => seq([76, null, 72], 0.22, "triangle", 0.25),
  whoosh: () => { const c = ac(); c && tone(200, c.currentTime, 0.25, "sawtooth", 0.06, 1200); },
  correct: () => seq([72, 76, 79, 84], 0.08, "square", 0.14),
  wrong: () => { const c = ac(); c && tone(220, c.currentTime, 0.4, "sawtooth", 0.12, 90); },
  reveal: () => seq([67, 72, 76, 79, 84], 0.07, "square", 0.12),
  fanfare: () => seq([72, 72, 72, 76, null, 72, 76, 79, null, null, 84], 0.11, "square", 0.14),
  heart: () => { seq([88, 91, 96, 100], 0.075, "triangle", 0.13); const c = ac(); c && tone(mf(103), c.currentTime + 0.34, 0.16, "sine", 0.07, mf(108)); },
};

const SONGS = {
  lobby: {
    bpm: 128,
    lead: [72, 0, 76, 0, 79, 0, 76, 0, 74, 0, 77, 0, 81, 0, 77, 0, 72, 0, 76, 0, 79, 0, 84, 0, 83, 0, 79, 0, 74, 0, 0, 0],
    bass: [48, 0, 0, 0, 55, 0, 0, 0, 50, 0, 0, 0, 53, 0, 0, 0, 48, 0, 0, 0, 55, 0, 0, 0, 55, 0, 0, 0, 43, 0, 0, 0],
  },
  think: {
    bpm: 150,
    lead: [69, 72, 76, 72, 69, 72, 76, 72, 67, 71, 74, 71, 67, 71, 74, 71, 65, 69, 72, 69, 65, 69, 72, 69, 64, 68, 71, 68, 64, 68, 71, 76],
    bass: [45, 0, 45, 0, 45, 0, 45, 0, 43, 0, 43, 0, 43, 0, 43, 0, 41, 0, 41, 0, 41, 0, 41, 0, 40, 0, 40, 0, 40, 0, 40, 0],
  },
};

let timer = null;
let current = null;

export const music = {
  play(name) {
    if (current === name) return;
    this.stop();
    const c = ac();
    if (!c) return;
    current = name;
    const song = SONGS[name];
    const dur = 60 / song.bpm / 2;
    let step = 0;
    let next = c.currentTime + 0.05;
    timer = setInterval(() => {
      while (next < c.currentTime + 0.25) {
        const l = song.lead[step % song.lead.length];
        const b = song.bass[step % song.bass.length];
        if (l) tone(mf(l), next, dur * 0.85, "square", 0.035);
        if (b) tone(mf(b), next, dur * 1.8, "triangle", 0.1);
        next += dur;
        step++;
      }
    }, 60);
  },
  stop() {
    clearInterval(timer);
    timer = null;
    current = null;
  },
};

export const isMuted = () => muted;
export function setMuted(m) {
  muted = m;
  localStorage.setItem("sq_muted", m ? "1" : "0");
  if (master) master.gain.value = m ? 0 : 0.5;
  listeners.forEach((fn) => fn(m));
}
export function onMuteChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
